import styled from 'styled-components';

import { HighCostMedRowMenuProps } from 'components/shared/highCostMeds/highCostMedListColumns';
import Menu from 'components/shared/menu';
import { useProfile } from 'context/profile';
import { PERMISSIONS } from 'models/Profile';
import { colors } from 'styles/theme/colors';
import PencilIconOutline from 'svg/PencilIconOutline';
import ThreeDotMenu from 'svg/ThreeDotMenu';
import TrashIcon from 'svg/TrashIcon';

// Each action gates on its own item permission, the way AdminDenialListRowMenu does. The list's edit
// permission covers the cost tier key alone and grants nothing here. An admin holding neither name —
// a View Only Olio Admin among them — gets no menu at all. See design 002, Authorization.
export default function HighCostMedRowMenu({ highCostMedicationListItem, onEdit, onRemove }: HighCostMedRowMenuProps) {
  const { profile } = useProfile();

  const canEdit = profile.has(PERMISSIONS.adminHighCostMedicationListItemEdit);
  const canRemove = profile.has(PERMISSIONS.adminHighCostMedicationListItemDelete);

  if (!canEdit && !canRemove) return null;

  return (
    <Menu $size='small'>
      <Menu.Trigger>
        <KebabButton type='button' aria-label='Row actions'>
          <ThreeDotMenu />
        </KebabButton>
      </Menu.Trigger>
      <Menu.Content position='right'>
        {canEdit && (
          <Menu.Item onClick={() => onEdit(highCostMedicationListItem)}>
            <PencilIconOutline width={14} height={14} />
            Edit medication details
          </Menu.Item>
        )}
        {canEdit && canRemove && <Menu.Divider />}
        {canRemove && (
          <RemoveItem onClick={() => onRemove(highCostMedicationListItem)}>
            <TrashIcon width={14} height={14} color={colors.red100} />
            Remove
          </RemoveItem>
        )}
      </Menu.Content>
    </Menu>
  );
}

const KebabButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border: none;
  background: transparent;
  cursor: pointer;
`;

const RemoveItem = styled(Menu.Item)`
  color: ${({ theme }) => theme.colors.red100};
`;
